<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("doctorsStock/getDetails", this.itemId);
    },
    computed: {
        doctorMedicine() {
            return this.$store.state.doctorsStock.doctorMedicine;
        }
    },
    data() {
        return {

            headers: [
                { text: ' الكمية', value: 'quantity' },
                { text: "مسجل بواسطة", value: "createdBy", sortable: false },
                { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
            ],
        };
    },
};
</script>